import Accept from 'shared/assets/icons/accept.svg?react';
import Admin from 'shared/assets/icons/admin.svg?react';
import Aquarius from 'shared/assets/icons/aquarius.svg?react';
import Aries from 'shared/assets/icons/aries.svg?react';
import BackArrow from 'shared/assets/icons/backArrow.svg?react';
import Biceps from 'shared/assets/icons/biceps.svg?react';
import BurgerMenu from 'shared/assets/icons/burgerMenu.svg?react';
import Cake from 'shared/assets/icons/cake.svg?react';
import Calendar from 'shared/assets/icons/calendar.svg?react';
import Cancer from 'shared/assets/icons/cancer.svg?react';
import Capricorn from 'shared/assets/icons/capricorn.svg?react';
import Cat from 'shared/assets/icons/cat.svg?react';
import Christmas from 'shared/assets/icons/christmas.svg?react';
import Clever from 'shared/assets/icons/clever.svg?react';
import Clock from 'shared/assets/icons/clock.svg?react';
import Close from 'shared/assets/icons/close.svg?react';
import Computer from 'shared/assets/icons/computer.svg?react';
import Confluence from 'shared/assets/icons/confluence.svg?react';
import Cube from 'shared/assets/icons/cube.svg?react';
import Cycle from 'shared/assets/icons/cycle.svg?react';
import Dancer from 'shared/assets/icons/dancer.svg?react';
import DataHub from 'shared/assets/icons/dataHub.svg?react';
import Dota from 'shared/assets/icons/dota.svg?react';
import Download from 'shared/assets/icons/downloadFile.svg?react';
import Edit from 'shared/assets/icons/edit.svg?react';
import Eternal from 'shared/assets/icons/eternal.svg?react';
import Eye from 'shared/assets/icons/eye.svg?react';
import Fairy from 'shared/assets/icons/fairy.svg?react';
import Gemini from 'shared/assets/icons/gemini.svg?react';
import GitLab from 'shared/assets/icons/gitlab.svg?react';
import Hackhaton from 'shared/assets/icons/hackhaton.svg?react';
import Hammer from 'shared/assets/icons/hammer.svg?react';
import Heart from 'shared/assets/icons/heart.svg?react';
import HeartEmodji from 'shared/assets/icons/heartEmodji.svg?react';
import Jira from 'shared/assets/icons/jira.svg?react';
import Leo from 'shared/assets/icons/leo.svg?react';
import Libra from 'shared/assets/icons/libra.svg?react';
import Link from 'shared/assets/icons/link.svg?react';
import Location from 'shared/assets/icons/location.svg?react';
import Lock from 'shared/assets/icons/lock.svg?react';
import Logout from 'shared/assets/icons/logout.svg?react';
import Mail from 'shared/assets/icons/mail.svg?react';
import Minus from 'shared/assets/icons/minus.svg?react';
import Navigation from 'shared/assets/icons/navigation.svg?react';
import Notebook from 'shared/assets/icons/notebook.svg?react';
import Number from 'shared/assets/icons/number.svg?react';
import Percent from 'shared/assets/icons/percent.svg?react';
import Phone from 'shared/assets/icons/phone.svg?react';
import Pisces from 'shared/assets/icons/pisces.svg?react';
import Play from 'shared/assets/icons/play.svg?react';
import Plus from 'shared/assets/icons/plus.svg?react';
import Present from 'shared/assets/icons/present.svg?react';
import Right from 'shared/assets/icons/right.svg?react';
import RightArrow from 'shared/assets/icons/rightArrow.svg?react';
import Run from 'shared/assets/icons/run.svg?react';
import Sagittarius from 'shared/assets/icons/sagittarius.svg?react';
import Santa from 'shared/assets/icons/santa.svg?react';
import Scorpio from 'shared/assets/icons/scorpio.svg?react';
import Search from 'shared/assets/icons/search.svg?react';
import Settings from 'shared/assets/icons/settings.svg?react';
import Share from 'shared/assets/icons/share.svg?react';
import Ski from 'shared/assets/icons/ski.svg?react';
import Snowflake from 'shared/assets/icons/snowflake.svg?react';
import Sparkles from 'shared/assets/icons/sparkles.svg?react';
import Star from 'shared/assets/icons/star.svg?react';
import Support from 'shared/assets/icons/support.svg?react';
import Tasks from 'shared/assets/icons/tasks.svg?react';
import Taurus from 'shared/assets/icons/taurus.svg?react';
import Team from 'shared/assets/icons/team.svg?react';
import TechnicalSupport from 'shared/assets/icons/technical-support.svg?react';
import Telegram from 'shared/assets/icons/telegram.svg?react';
import Tennis from 'shared/assets/icons/tennis.svg?react';
import Thanks from 'shared/assets/icons/thanks.svg?react';
import Think from 'shared/assets/icons/think.svg?react';
import Trash from 'shared/assets/icons/trash.svg?react';
import Up from 'shared/assets/icons/up.svg?react';
import User from 'shared/assets/icons/user.svg?react';
import Virgo from 'shared/assets/icons/virgo.svg?react';
import Vk from 'shared/assets/icons/vk.svg?react';
import Walk from 'shared/assets/icons/walk.svg?react';
import Winner from 'shared/assets/icons/winner.svg?react';

export const icons = {
  link: Link,
  jira: Jira,
  confluence: Confluence,
  gitlab: GitLab,
  admin: Admin,
  dataHub: DataHub,
  cake: Cake,
  cycle: Cycle,
  hackhaton: Hackhaton,
  hammer: Hammer,
  lock: Lock,
  number: Number,
  present: Present,
  run: Run,
  ski: Ski,
  snowflake: Snowflake,
  tennis: Tennis,
  walk: Walk,
  logout: Logout,
  accept: Accept,
  close: Close,
  edit: Edit,
  backArrow: BackArrow,
  burgerMenu: BurgerMenu,
  calendar: Calendar,
  telegram: Telegram,
  mail: Mail,
  phone: Phone,
  download: Download,
  minus: Minus,
  plus: Plus,
  right: Right,
  rightArrow: RightArrow,
  search: Search,
  settings: Settings,
  up: Up,
  cube: Cube,
  dota: Dota,
  computer: Computer,
  christmas: Christmas,
  santa: Santa,
  winner: Winner,
  fairy: Fairy,
  cat: Cat,
  dancer: Dancer,
  think: Think,
  biceps: Biceps,
  support: Support,
  thanks: Thanks,
  eternal: Eternal,
  play: Play,
  heart: Heart,
  star: Star,
  trash: Trash,
  eye: Eye,
  technicalSupport: TechnicalSupport,
  tasks: Tasks,
  team: Team,
  cancer: Cancer,
  leo: Leo,
  sagittarius: Sagittarius,
  aquarius: Aquarius,
  aries: Aries,
  capricorn: Capricorn,
  gemini: Gemini,
  libra: Libra,
  pisces: Pisces,
  scorpio: Scorpio,
  taurus: Taurus,
  virgo: Virgo,
  vk: Vk,
  percent: Percent,
  clock: Clock,
  user: User,
  location: Location,
  navigation: Navigation,
  share: Share,
  clever: Clever,
  sparkles: Sparkles,
  heartEmodji: HeartEmodji,
  notebook: Notebook,
} as const;
